import React from 'react';
import { KEY_CODES } from 'utility/constants';

interface SignInButtonProps {
  label: string;
  icon: React.ReactElement;
  onClickHandler: () => void;
}

const SignInButton = ({ label, icon, onClickHandler }: SignInButtonProps) => {
  return (
    <button
      type="button"
      className="sign-in-button-common hmf-py-xs hmf-px-l hmf-display-flex hmf-justify-content-center hmf-align-items-flex-end"
      aria-label={label}
      onClick={onClickHandler}
      onKeyDown={(event) => {
        if (event.key === KEY_CODES.SPACE || event.key === KEY_CODES.ENTER) {
          onClickHandler();
        }
      }}>
      {icon}
    </button>
  );
};

export default SignInButton;
